import React from "react";
import { isVariantPackage } from "../utils/explorePackage";
import "./PackageBottomNote.css";

const PackageBottomNote = ({ course, onOpenVariants, className = "" }) => {
  if (!course?.bottom_note) return null;

  const isClickable = isVariantPackage(course) && typeof onOpenVariants === "function";
  const classNames = [
    "package-bottom-note",
    isClickable ? "package-bottom-note--clickable" : "package-bottom-note--static",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (isClickable) {
    return (
      <button
        type="button"
        className={classNames}
        onClick={() => onOpenVariants(course)}
      >
        {course.bottom_note}
      </button>
    );
  }

  return <p className={classNames}>{course.bottom_note}</p>;
};

export default PackageBottomNote;
